<template>
    <v-col class="tooltip-content elevation-4">
        <v-row
            class="caption grey--text font-weight-medium ml-1"
            style="flex-wrap: nowrap; white-space: nowrap"
        >
            {{ getStartEndLabel }}
        </v-row>
        <InfoRow
            class="mx-1"
            :rows="timeCategories"
        />
        <v-divider class="g2 my-2"/>
        <InfoRow
            class="mx-1"
            :rows="[taskRow]"
        />
    </v-col>
</template>

<script>
import {computed} from "@vue/composition-api";
import {formatTimeDuration, formatDate} from "../../../plugins/formatting";
import {$t} from "../../../i18n";
import InfoRow from "./InfoRows.vue";

export default {
    name: 'CustomTooltip',
    components: {InfoRow},
    props: {
        segment: {
            type: Object,
            default: null,
        }
    },
    setup(props) {
        const getTotal = computed(() => {
            const totalAsSeconds = props.segment.billable + props.segment.non_billable
            return formatTimeDuration(totalAsSeconds)
        })

        const getStartEndLabel = computed(() => {
            const formattedStartDate = formatDate(props.segment.start_date)
            const formattedEndDate = formatDate(props.segment.end_date)

            if (formattedStartDate === formattedEndDate) {
                return `${formattedStartDate}`
            }
            return `${formattedStartDate} - ${formattedEndDate}`
        })

        const timeCategories = computed(() => {
            return [
                {
                    label: props.segment.label,
                    value: getTotal.value,
                    valueColor: "black",
                    labelClasses: ['subtitle-1'],
                    valueClasses: ['subtitle-1'],
                    rowClasses: ['mb-1']
                },
                {
                    label: $t("Extra"),
                    value: formatTimeDuration(props.segment.extra),
                    valueColor: "black",
                },
                {
                    label: $t("Billable"),
                    value: formatTimeDuration(props.segment.billable),
                    valueColor: "#38B000",
                },
                {
                    label: $t("Non-billable"),
                    value: formatTimeDuration(props.segment.non_billable),
                    valueColor: "#FD4B78",
                },
            ]
        })

        const taskRow = {
            label: $t("Tasks") + " " + $t("done"),
            value: props.segment.completed_tasks_count,
            valueColor: "black",
        }

        return {
            timeCategories,
            getTotal,
            taskRow,
            getStartEndLabel,
        }
    }
}
</script>

<style scoped>
.tooltip-content {
    width: 222px;
    background: #fff;
    border-radius: 8px;
}
</style>
